import {
  GetWorkspaceRequest,
  GetWorkspacesRequest,
  GetWorkspaceConnectedApplicationsRequest,
} from 'lib/generated/api'
import { useQueries, useQuery } from 'react-query'
import { useApiClient } from 'contexts/ApiClientContext'

export const useGetWorkspaces = (request: GetWorkspacesRequest) => {
  const { workspaceApi } = useApiClient()
  return useQuery(
    ['getWorkspaces', request.organizationId],
    () => workspaceApi.getWorkspaces(request),
    {
      // do not fetch unless manually requested
      refetchOnWindowFocus: false,
      enabled: !!request.organizationId,
    }
  )
}

export const useGetOrganizationsWorkspaces = (
  requests: { organizationId: string | undefined }[]
) => {
  const { workspaceApi } = useApiClient()
  const queries = requests.filter(
    request => !!request.organizationId
  ) as GetWorkspacesRequest[]
  return useQueries(
    queries.map(request => {
      return {
        queryKey: ['getWorkspaces', request.organizationId],
        queryFn: () => workspaceApi.getWorkspaces(request),
        enabled: !!request.organizationId,
      }
    })
  )
}

export const useGetWorkspace = (request: GetWorkspaceRequest) => {
  const { workspaceApi } = useApiClient()
  return useQuery(
    ['getWorkspace', request.workspaceId],
    () => workspaceApi.getWorkspace(request),
    {
      // do not fetch unless manually requested
      enabled: !!request.workspaceId && !!request.organizationId,
    }
  )
}

export const useGetWorkspaceConnectedApplications = (
  request: GetWorkspaceConnectedApplicationsRequest
) => {
  const { workspaceApi } = useApiClient()
  return useQuery(
    [
      'getWorkspaceConnectedApplications',
      request.organizationId,
      request.workspaceId,
    ],
    () => workspaceApi.getWorkspaceConnectedApplications(request),
    {
      // Do not fetch unless manually requested
      enabled: false,
    }
  )
}
